import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "detail-section mt-3" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "small text-muted" }
const _hoisted_4 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}


export default {
  __name: 'StudentPendingPointReturns',
  props: {
  entries: {
    type: Array,
    default: () => [],
  },
  formatDate: {
    type: Function,
    required: true,
  },
  formatTime: {
    type: Function,
    required: true,
  },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "text-muted section-title" }, " Ausstehende Punkterückgaben ", -1 /* CACHED */)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.entries, (entry) => {
      return (_openBlock(), _createElementBlock("div", {
        key: entry.id,
        class: "mb-2"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(entry.points) + " Punkte", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_3, " bis " + _toDisplayString(__props.formatDate(entry.validUntil)) + " " + _toDisplayString(__props.formatTime(entry.validUntil)), 1 /* TEXT */)
        ]),
        (entry.bookingTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(entry.bookingTitle), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    (!__props.entries.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Keine ausstehenden Rückgaben "))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}